import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
// import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
const Overview = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Overview.vue')
const Widgets = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Widgets.vue')

// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from 'src/components/Dashboard/Views/Login.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'
import Help from 'src/components/Dashboard/Views/Help.vue'

// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

// Forms pages
const RegularForms  = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/RegularForms.vue')
const ExtendedForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ExtendedForms.vue');
const ValidationForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ValidationForms.vue')
const Wizard = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/Wizard.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/RegularTables.vue');
const ExtendedTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/ExtendedTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/PaginatedTables.vue');
// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/GoogleMaps.vue')
const FullScreenMap = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/FullScreenMap.vue')
const VectorMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue');

// Calendar
import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// Charts
const Charts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Charts.vue')

// Home
import Home from 'src/components/Dashboard/Views/Home.vue'
// Reports
import Reports from 'src/components/Dashboard/Views/Reports.vue'
// import Reports from 'src/components/Dashboard/Views/Reporte/Reportes.vue'
// Zones
import Zones from 'src/components/Dashboard/Views/Zones.vue'
// Trends
import Trends from 'src/components/Dashboard/Views/Trends.vue'
// Not Found Page
import NotFound from 'src/components/Dashboard/Views/NotFoundPage.vue'
//Settings
import Settings from 'src/components/Dashboard/Views/Settings.vue'
// detalleReportes
import DetalleReporte from 'src/components/Dashboard/Views/DetalleReporte.vue'
// HistoricoMapa
import HistoricoMapa from 'src/components/Dashboard/Views/HistoricoMapa.vue'
// HeatMap
import HeatMap from 'src/components/Dashboard/Views/HeatMap.vue'

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login,
  meta: {
    public: true,  // Acceso público para poder loguearse
    onlyWhenLoggedOut: true
  }
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [

  loginPage,
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Recorridos',
        component: Home,
        meta: {
            public: false,          // Solo accede si está logueado
            onlyWhenLoggedOut: false
          }
      },
      {
        path: 'reports',
        name: 'Reportes de Recorridos Diarios',
        component: Reports,
        meta: {
            public: false,          // Solo accede si está logueado
            onlyWhenLoggedOut: false
          }
      },
      {
        path: 'reportDetail',
        name: 'Detalle de Recorrido Diario',
        component: DetalleReporte,
        meta: {
            public: false,          // Solo accede si está logueado
            onlyWhenLoggedOut: false
          }
      },
      {
        path: 'trends',
        name: 'Tendencias',
        component: Trends,
        meta: {
            public: false,          // Solo accede si está logueado
            onlyWhenLoggedOut: false
          }
      },
      {
        path: 'zones',
        name: 'Consultas de Recorridos en Geocercas',
        component: Zones,
        meta: {
            public: false,          // Solo accede si está logueado
            onlyWhenLoggedOut: false
          }
      },
      {
        path: 'storymap',
        name: 'Mapa Histórico',
        component: HistoricoMapa,
        meta: {
          public: false,          // Solo accede si está logueado
          onlyWhenLoggedOut: false
        }
      },
      {
        path: 'heatmap',
        name: 'Mapa de Calor',
        component: HeatMap,
        meta: {
          public: false,          // Solo accede si está logueado
          onlyWhenLoggedOut: false
        }
      },
      {
        path: 'settings',
        name: 'Configuración',
        component: Settings,
        meta: {
            public: false,          // Solo accede si está logueado
            onlyWhenLoggedOut: false
          }
      },
      {
        path: 'help',
        name: 'Manual de Ayuda',
        component: Help,
        meta: {
            public: true,
            onlyWhenLoggedOut: false
          }
      }
    ]
  },
  {path: '*', component: NotFound}
];

export default routes
